import React, { FunctionComponent, useRef, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import Profile from 'views/profile';
import Header from 'components/header/index';
import Footer from 'components/footer/Footer';
import LeftNavBar, { getSettingsPageTitle } from 'components/leftNavBar/LeftNavBar';
import Styles from 'views/profile/landing/MenuLanding.module.scss';
import SettingsPhoneHeader from 'views/profile/landing/SettingsPhoneHeader';
import PrivacyPolicy from 'views/privacyPolicy/PrivacyPolicy';
import TermAndConditions from 'views/termAndConditions/TermAndConditions';
import Subscription from 'views/subscription';
import FeedBack from 'views/feedBack';
import Notifications from 'views/notifications';
import DateAndTime from 'views/dateAndTime';
import Currency from 'views/currency';
import InviteFriend from 'views/inviteFriend';
import ExplainerVideo from 'views/explainerVideo/ExplainerVideo';
import EmailNotifications from 'views/emailNotifications';
import { MenuBottomActionsProvider } from 'views/profile/landing/MenuBottomActionsContext';
import { featureFlags } from 'config/featureFlags';

const MenuLandingContent: FunctionComponent<{
  menuOpen: boolean;
  closeMenu: () => void;
  toggleMenu: () => void;
  bottomActionsRef: React.RefObject<HTMLDivElement>;
}> = ({ menuOpen, closeMenu, toggleMenu, bottomActionsRef }) => {
  const { pathname } = useLocation();
  const pageTitle = getSettingsPageTitle(pathname);

  return (
    <div className={`custom-container ${Styles.pageContainer}`}>
      <SettingsPhoneHeader title={pageTitle} onMenuClick={toggleMenu} />

      <div className={`${Styles.menuLandingWrapper} ${menuOpen ? Styles.menuOpen : ''}`}>
        {menuOpen && <div className={Styles.menuOverlay} onClick={closeMenu} />}

        <div className={Styles.contentRow}>
          <div className={Styles.leftSide}>
            <LeftNavBar onLinkClick={closeMenu} />
          </div>

          <div className={Styles.rightSide}>
            <div className={Styles.rightSideMain}>
              <Switch>
                <Route exact path="/subscription">         <Subscription />       </Route>
                {featureFlags.showExplainerVideo && (<Route exact path="/explainer-video">      <ExplainerVideo />     </Route>)}
                <Route exact path="/invite-friend">        <InviteFriend />       </Route>
                <Route exact path="/currency">             <Currency />           </Route>
                <Route exact path="/profile/edit">         <Profile />            </Route>
                <Route exact path="/date-and-time">        <DateAndTime />        </Route>
                {featureFlags.showNotificationsSettings && (
                  <Route exact path="/notifications">        <Notifications />      </Route>
                )}
                <Route exact path="/email-notifications">  <EmailNotifications /> </Route>
                <Route exact path="/feedback">             <FeedBack />           </Route>
                <Route exact path="/terms-and-conditions"> <TermAndConditions />  </Route>
                <Route exact path="/privacy-policy">       <PrivacyPolicy />      </Route>
              </Switch>
            </div>

            {/* Inside right column so Cancel/Save sit under page content, not below full sidebar height */}
            <div className={Styles.bottomBar}>
              <div className={Styles.bottomBarActions} ref={bottomActionsRef} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const MenuLanding: FunctionComponent = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const bottomActionsRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu  = () => setMenuOpen(false);

  return (
    <div className={`settingsPageShell ${Styles.settingsPageShell}`}>
      <Header hideOnPhone />
      <MenuBottomActionsProvider value={bottomActionsRef}>
        <MenuLandingContent
          menuOpen={menuOpen}
          closeMenu={closeMenu}
          toggleMenu={toggleMenu}
          bottomActionsRef={bottomActionsRef}
        />
      </MenuBottomActionsProvider>
      <div className={Styles.settingsFooterSlot}>
        <Footer />
      </div>
    </div>
  );
};

export default MenuLanding;
